import { cn } from "@/lib/utils";

interface SkeletonProps {
  className?: string;
  rounded?: "sm" | "md" | "lg" | "full";
}

export function Skeleton({ className, rounded = "md" }: SkeletonProps) {
  const roundedClass =
    rounded === "full"
      ? "rounded-full"
      : rounded === "lg"
      ? "rounded-lg"
      : rounded === "sm"
      ? "rounded-sm"
      : "rounded-md";

  return <div className={cn("skeleton", roundedClass, className)} />;
}

export function SkeletonText({
  lines = 3,
  className,
  lineHeight = "h-3",
}: {
  lines?: number;
  className?: string;
  lineHeight?: string;
}) {
  return (
    <div className={cn("space-y-2", className)}>
      {Array.from({ length: lines }).map((_, i) => (
        <Skeleton
          key={i}
          className={cn(lineHeight, i === lines - 1 ? "w-2/3" : "w-full")}
        />
      ))}
    </div>
  );
}

export function SkeletonCard({ className }: { className?: string }) {
  return (
    <div
      className={cn(
        "p-4 rounded-xl border border-border/30 bg-card/40 space-y-3",
        className
      )}
    >
      <div className="flex items-center gap-3">
        <Skeleton className="w-9 h-9" rounded="lg" />
        <div className="flex-1 space-y-1.5">
          <Skeleton className="h-3 w-1/2" />
          <Skeleton className="h-2.5 w-1/3" />
        </div>
      </div>
      <SkeletonText lines={2} lineHeight="h-2.5" />
    </div>
  );
}

export function SkeletonList({ count = 5 }: { count?: number }) {
  return (
    <div className="space-y-1.5">
      {Array.from({ length: count }).map((_, i) => (
        <div
          key={i}
          className="flex items-center gap-3 p-2.5 rounded-lg border border-border/20"
        >
          <Skeleton className="w-4 h-4" rounded="sm" />
          <Skeleton className="h-3 flex-1" />
          <Skeleton className="h-2.5 w-16" />
        </div>
      ))}
    </div>
  );
}